import { render, staticRenderFns } from "./plLazy.vue?vue&type=template&id=122ace30&scoped=true"
import script from "./plLazy.vue?vue&type=script&lang=js"
export * from "./plLazy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ace30",
  null
  
)

export default component.exports